// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mostCommonWord{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 16px;
    gap: 12px;

    width: 100%;
    height: 100%;
}

.mostCommonWord_head{
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    text-align: center;

    color: #6F6F6F;
}

.mostCommonWord_word{
    font-weight: 600;
    font-size: 48px;
    line-height: 56px;
    text-align: center;

    color: #FFA825;
}

.mostCommonWord_used{
    font-style: italic;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    text-align: center;

    color: #00000099;
}

.mostCommonWord_used_count{
    font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/pages/meetingPage/components/mostCommonWord/MostCommonWord.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,SAAS;;IAET,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;;IAElB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;;IAElB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;;IAElB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".mostCommonWord{\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 16px;\n    gap: 12px;\n\n    width: 100%;\n    height: 100%;\n}\n\n.mostCommonWord_head{\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 24px;\n    text-align: center;\n\n    color: #6F6F6F;\n}\n\n.mostCommonWord_word{\n    font-weight: 600;\n    font-size: 48px;\n    line-height: 56px;\n    text-align: center;\n\n    color: #FFA825;\n}\n\n.mostCommonWord_used{\n    font-style: italic;\n    font-weight: 400;\n    font-size: 15px;\n    line-height: 20px;\n    text-align: center;\n\n    color: #00000099;\n}\n\n.mostCommonWord_used_count{\n    font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
